import '../scss/login.scss';

import { default as BaseApp } from './base.App.js';
import { default as Utils } from './utils/base.Utils.js';
import { default as Services } from './services/base.Services.js';
import MD5 from 'crypto-js/md5'
import * as microsoftTeams from '@microsoft/teams-js';

import string_it from '../localization/login_it.js';
import string_en from '../localization/login_en.js';
import AccessDeniedModal from '../modals/accessDenied/js/accessDenied';
export default class Login extends BaseApp {

  constructor(userName) {
    super();

    super.localStrings = {
      en: {...string_en[0]},
      it: {...string_it[0]}
    };

    if(userName){
      this.teams = true;
    }
    this.customerEmail = userName ? userName : Utils.Customer.getCustomerEmail();
    this.checkAccessValidity();
  }

  addTeamsLoginHandlers(){
    $('#teamsBtn').on('click', (e) => {
      this.doTeamsLogin();
    });
  }

  addXuniplayLoginHandlers(){
    //where overrideSSO is true
    $('#loginBtn').on('click', (e) => {
      // if (this.customerEmail == null || this.customerEmail.length < 1) {
      //   this.customerEmail = $("#emailBox").val();
      // }
      this.customerEmail = $("#emailBox").val();
      this.domainCode = $("#domainCode").val();
      this.mobileEnvironment = $("mobileEnvironment").val();
      this.doLogin();
    });

    $('.ssoLoginBtn').on('click', (e) => {

      $("body").removeClass("wh-login");
      $(".login-box").css("display", "none");
      $('body').removeClass('error')

      $('body').addClass('wh-sso-login');
      $(".sso-login-box").css("display", "flex");

      this.addSSOLoginHandlers();
    });

    $('.forgotPswBtn').on('click', (e) => {

      //Nascondi la schermata di login
      $("body").removeClass("wh-login");
      $(".login-box").css("display", "none");
      $('body').removeClass('error')

      //Mostra quella di reset password
      $('body').addClass('wh-forgot-psw');
      $(".forgotten-password-box").css("display", "flex");

      this.addForgottenPasswordHandlers();
    });

    $('body').keyup(function(event) {
      if (event.keyCode === 13) { //ENTER key
          $("#loginBtn").click();
      }
    });

    // $(window).on('keyup', (ev) => {
    //   let keycode = (ev.keyCode ? ev.keyCode : ev.which);
    //   if (keycode == '13') {
    //     this.doLogin();
    //   }
    // })
  }

  addSSOLoginHandlers() {

    //sso login
    $('#loginSSOBtn').on('click', (e) => {
      this.customerEmail = $("#emailSSOBox").val();
      if (this.customerEmail != null && this.customerEmail.length > 0) {

        // $('body').removeClass('wh-sso-login');
        // $(".sso-login-box").css("display", "none");
        this.verifyCurrentUser(true);

      } else {
        $('body').addClass('error');
      }
    })

    //Remove previous listener
    $('body').off('keyup');
    $('body').keyup(function(event) {
      if (event.keyCode === 13) { //ENTER key
          $("#loginSSOBtn").click();
      }
    });

    $('.backbutton').on('click', (e) => {
      $('body').off('keyup');
      $('body').keyup(function(event) {
        if (event.keyCode === 13) { //ENTER key
            $("#loginBtn").click();
        }
      });

      $('body').removeClass('error');

      $('body').removeClass('wh-sso-login');
      $("#emailSSOBox").val("");
      $("#password").val("");
      $(".sso-login-box").css("display", "none");
      $(".sso-login-box .error").css('display', 'none');

      $("body").addClass("wh-login");
      $(".login-box").css("display", "flex");

    })
  }

  addForgottenPasswordHandlers() {
    
    const errorField = document.getElementById("forgotPsw_error");
    const passwordBtn = document.getElementById("restorePswBtn");
    passwordBtn.style.display = ''; //In ogni caso abilita il pulsante (potrebbe essere stato nascosto)
    errorField.style.display = 'none';
    //sso login
    $('#restorePswBtn').on('click', (e) => {
      const customerEmail = $("#forgotPsw_email").val();
      if (customerEmail != null && customerEmail.length > 0) {

        // $('body').removeClass('wh-sso-login');
        // $(".sso-login-box").css("display", "none");
        this.resetPassword(customerEmail);

      } else {
        $('body').addClass('error');
      }
    })

    //Remove previous listener
    $('body').off('keyup');
    $('body').keyup(function(event) {
      if (event.keyCode === 13) { //ENTER key
          $("#restorePswBtn").click();
      }
    });
    
    $('.backbutton').on('click', (e) => {
      $(".forgotten-password-box").css("display", "none");
      $('#restorePswBtn').off('click');
      $('body').off('keyup');
      $('body').keyup(function(event) {
        if (event.keyCode === 13) { //ENTER key
            $("#loginBtn").click();
        }
      });

      $('body').removeClass('error');

      $('body').removeClass('wh-sso-login');
      $("#emailSSOBox").val("");
      $("#password").val("");
      $(".sso-login-box").css("display", "none");
      $(".sso-login-box .error").css('display', 'none');

      $("body").addClass("wh-login");
      $(".login-box").css("display", "flex");

    })
  }

  doTeamsLogin(){

    $('body').addClass('wait');
    Utils.Logger.info('LOGIN', 'cas: ' + this.cas);
    microsoftTeams.authentication.authenticate({
      url: this.cas, //location.origin + '/workheraOutlookPlugin/auth.end.html'
      width: 600,
      height: 535,
      successCallback: (result) => {
        window.location = result;
      },
      failureCallback: (reason) => {
        this.manageException(reason, 'Fault on authenticate');
        $(".teams-box").css("display", "none");
        $('body').addClass('error');
      }
    });
  }

  checkAccessValidity() {
    Services.FindAndBook.getCurrentCustomer().then(
      data => {
        window.location = window.location.href.replace('login', 'index');
      },
      fault => {
        this.manageException(fault, 'Fault on getCurrentUser');
        this.verifyCurrentUser(false);
      }
    ).catch(err => {
      this.manageException(err, 'Catch on getCurrentUser');
      this.verifyCurrentUser(false);
    });
  }

  verifyCurrentUser(throwError) {
    Utils.Cookie.remove('CustomerToken');
    Utils.Cookie.remove('MobileCode');
    Utils.Cookie.remove('jwttoken');

    if (this.customerEmail != null && this.customerEmail.length > 0) {

      this.doSSOLogin(this.customerEmail, throwError);

    } else {

      this.addXuniplayLoginHandlers();
      if ($("input.domain").val() == 'acciaiterni') {
        //Rimuovi il pulsante indietro
        $("body").addClass("wh-sso-login");
        $(".sso-login-box").css("display", "flex");
        $("#sso-back-btn").css("display", "none");
        this.addSSOLoginHandlers();
      } else {
        $("body").addClass("wh-login");
        $(".login-box").css("display", "flex");
      }
      $("#emailBox").show();
    }
  }

  doLogin() {
    const fixedDomainName = $("input.domain").val();
    Services.FindAndBook.login(this.customerEmail, MD5($('#password').val()), this.domainCode || fixedDomainName, this.mobileEnvironment).then(
      loginResult => {
        Utils.Cookie.set('CustomerToken', loginResult.data.LoginResult.AccessToken, { expires: 1, sameSite: 'none', secure: location.href.indexOf('localhost') == -1 });
        if(Utils.Cookie.get('CustomerToken') != loginResult.data.LoginResult.AccessToken)
          Utils.Cookie.set('CustomerToken', loginResult.data.LoginResult.AccessToken);

        Utils.Cookie.set('MobileCode', loginResult.data.MobileCode, { expires: 1, sameSite: 'none', secure: location.href.indexOf('localhost') == -1 });
        if(Utils.Cookie.get('MobileCode') != loginResult.data.MobileCode)
          Utils.Cookie.set('MobileCode', loginResult.data.MobileCode);
        
        Utils.Cookie.set('iddomain', loginResult.data.IDDomain, { expires: 1, sameSite: 'none', secure: location.href.indexOf('localhost') == -1 });
        if(Utils.Cookie.get('iddomain') != loginResult.data.IDDomain)
          Utils.Cookie.set('iddomain', loginResult.data.IDDomain);
        
        Utils.Cookie.set('webAppInformation', loginResult.data.LoginResult, { expires: 1, sameSite: 'none', secure: location.href.indexOf('localhost') == -1 });
        if(Utils.Cookie.get('webAppInformation') != loginResult.data.LoginResult)
          Utils.Cookie.set('webAppInformation', loginResult.data.LoginResult);

        window.location = window.location.href.replace('login', 'index');
      },
      fault => {
        this.manageException(fault, 'Fault on Login');
        //NOTE: Errors with FaultCode 50022 refer to SSO authentication required errors
        //In this case show a different message!!!
        const errorField = document.getElementById("error_field");
        switch (fault.FaultCode) {
          case 50022:
            errorField.innerHTML = `<span>${this.localStrings.sso_login_error}</span>`
          break;
          case 50008: case 50007:
            errorField.innerHTML = `<span>${this.localStrings.missing_user_error}</span>`
          break;
          case 31010:
            errorField.innerHTML = `<span>${this.localStrings.account_locked_error}</span>`
          break;
          case 403:
            errorField.innerHTML = `<span>${this.localStrings.access_not_enabled}</span>`
            const popup = new AccessDeniedModal({});
            $(popup.wrapper).on('modal-close', (e) => {
              $(popup.wrapper).off('modal-close');
            });
            popup.open();
          break;
          default:
            errorField.innerHTML = `<span>${this.localStrings.login_error}</span>`
        }
        $('body').addClass('error');
      }
    ).catch(err => {
      this.manageException(err, 'Catch on Login');
      $('body').addClass('error');
    });
  }

  doSSOLogin(customerEmail, throwError) {
    Services.FindAndBook.getSSOInfoByEmail(customerEmail).then(
      data => {

        this.ssoInfo = data;
        if(data.data.SSO.Enabled && !kendo.parseQueryStringParams(document.location.search).overrideSSO) {
          Utils.Cookie.set('iddomain', data.data.SSO.IDDomain, { expires: 1, sameSite: "none", secure: location.href.indexOf('localhost') == -1 });
          let service = window.location.search ? window.location.href.replace('login', 'index').replace(window.location.search, '?domainid=' + data.data.SSO.IDDomain) : window.location.href.replace('login', 'index') + '?domainid=' + data.data.SSO.IDDomain;
          service = 'service=' + encodeURIComponent(service + (this.teams ? '&teamsAuth=true' : ''));
          let toReplace = data.data.SSO.URL.substring(data.data.SSO.URL.indexOf('service='),  data.data.SSO.URL.length);
          this.cas = data.data.SSO.URL.replace(toReplace, service);
          if(!this.teams){
            window.location = this.cas;
          } else {
            this.addTeamsLoginHandlers();
            $('body').addClass('teams-login');
            $(".teams-box").css("display", "flex");
          }
        } else {
          if (!throwError) {
            this.addXuniplayLoginHandlers();

            $('body').addClass('wh-login');
            $(".login-box").css("display", "flex");
            $('.email').show();
            $('.email').css('margin-bottom', '1rem')
            $('.email').text(customerEmail);
          } else {
            //SSO not available for domain
            $('body').addClass('error');
            $("#sso-error").text(this.localStrings["generic_error"]);

          }
        }
      },
      fault => {
        this.manageException(fault, 'Fault on getSSOInfoByEmail');
        $('body').addClass('error');
        $(".sso-login-box .error").css('display', 'flex');
        $("#sso-error").text(this.localStrings["login_error"]);
      }
    ).catch(err => {
      this.manageException(err, 'Catch on getSSOInfoByEmail');
      $('body').addClass('error');
      $(".sso-login-box .error").css('display', 'flex');
      $("#sso-error").text(this.localStrings["login_error"]);
    });
  }

  resetPassword(customerEmail) {
    let domainCode = null;
    let mobileEnvironment = null;
    //Potremmo essere in una pagina di login custom. Verifica se esistono dati
    const domainInfo = document.querySelector('.domain');
    if (domainInfo) {
      domainCode = domainInfo.value;
    }

    const errorField = document.getElementById("forgotPsw_error");
    const resetBtn = document.getElementById("restorePswBtn");
    //A partire dalla mail trova il cliente
    Services.FindAndBook.resetPassword(customerEmail, 'base', domainCode).then((el) => {
      //$(".backbutton").click();
      errorField.style.display = 'block';
      errorField.style.color = 'green';
      errorField.innerHTML = `<span>${this.localStrings.forgotPsw_success}</span>`
      resetBtn.style.display = 'none'; //Ultima cosa da fare se tutto va bene
    }).catch((err) => {
      errorField.style.display = 'block';
      errorField.style.color = 'red';
      switch (err.FaultCode) {
        case 50002:
        case 50007:
          errorField.innerHTML = `<span>${this.localStrings.forgotPsw_mail_error}</span>`
        break;
        case 50023:
          errorField.innerHTML = `<span>${this.localStrings.forgotPsw_SSO_error}</span>`
        break;
        default:
          errorField.innerHTML = `<span>${this.localStrings.forgotPsw_generic_error}</span>`
      }
    });
  }

  manageException(error, message) {
    Utils.Logger.log('LOGIN', message, error);
  }
}
document.addEventListener('DOMContentLoaded', (event) => {
  if(kendo.parseQueryStringParams(document.location.search).teams) {
    microsoftTeams.initialize(() => {
      microsoftTeams.getContext((context, error) => {
        let userName = Object.keys(context).length > 0 ? context['upn'] : '';
        window.App = new Login(userName);
      });
    });
  } else {
    window.App = new Login();
  }
});
